import { SmallPagePaper } from '~/common/components';
import { LoginForm } from '~/components/forms/LoginForm';

export const LoginPage = () => (
  <SmallPagePaper>
    <LoginForm />
  </SmallPagePaper>
);
